<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des réservations"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/event-date-booking/list"
                :searchArgs="searchArgs"
                :trash="dataTrash">
        </DynamicCardList>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'EventDateBookingList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'eventDateTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date'),
                        key: 'eventDateStart',
                        type: 'dateTime',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Place'),
                        key: 'quantity',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'eventDateTitle'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'eventDateStart'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'status'
                                        }
                                    ]
                                },
                                {}
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'eventDateTitle',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        },
                        {
                            id: 'eventDateStart',
                            type: 'date',
                            label: Core.Definition.getDefinition('Date'),
                            value: '',
                        },
                        {
                            id: 'status',
                            type: 'select',
                            label: Core.Definition.getDefinition('État'),
                            value: null,
                            onSelect: function() {}
                        }
                    ]
                },
                dataEdit: {
                    show: false
                },
                dataTrash: {
                    show: false
                }
            }
        },
        methods: {
        }
    }
</script>
